import { render } from "./MatchContent.vue?vue&type=template&id=268871ba&scoped=true"
import script from "./MatchContent.vue?vue&type=script&lang=js"
export * from "./MatchContent.vue?vue&type=script&lang=js"

import "./MatchContent.vue?vue&type=style&index=0&id=268871ba&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268871ba"]])

export default __exports__